<template>
  <div>
    <div style="width: 1360px; margin: 6px auto;">
      <div class="infos card">
        <div class="col" style="width: 450px">
          <div class="image-container">
            <img
              :src="imageSpecies"
              style="width: 480px; height: 520px; object-fit: contain"
              alt="Image not found..."
            />
          </div>
        </div>
        <div class="col" style="width: 450px">
          <div class="inner">
            <div class="title">
              <svg
                t="1705747048918"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="12846"
                width="30"
                height="30"
              >
                <path
                  d="M546.325 929.545H175.081c-26.642 0-48.042-22.988-48.042-51.609V146.06c0-28.617 21.4-51.605 48.042-51.605h620.198c26.641 0 48.041 22.988 48.041 51.605v178.278c0 18.299-13.537 32.84-30.572 32.84-17.031 0-30.572-14.541-30.572-32.84V160.136H188.185V863.86h358.141c17.036 0 30.573 14.545 30.573 32.841-0.001 18.298-13.538 32.844-30.574 32.844z m0 0"
                  p-id="12847"
                  fill="#8a8a8a"
                ></path>
                <path
                  d="M618.393 359.527H264.616c-17.031 0-30.572-14.545-30.572-32.84 0-18.3 13.541-32.845 30.572-32.845h353.776c17.031 0 30.573 14.545 30.573 32.845 0.001 18.295-13.541 32.84-30.572 32.84zM507.018 544.838H262.435c-17.037 0-30.573-14.541-30.573-32.84 0-18.295 13.537-32.841 30.573-32.841h244.583c17.036 0 30.573 14.545 30.573 32.841 0 18.299-13.537 32.84-30.573 32.84zM454.607 709.04H262.435c-17.037 0-30.573-14.541-30.573-32.841 0-18.295 13.537-32.841 30.573-32.841h192.172c17.036 0 30.573 14.546 30.573 32.841 0 18.3-13.537 32.841-30.573 32.841z m175.14 54.424c-8.734 22.049-16.161 45.976-23.146 72.249-1.749 7.036-8.302 10.791-14.854 8.912-6.548-1.876-10.042-8.912-8.297-15.951 8.297-32.84 18.344-62.396 29.265-88.669-14.416-32.841-19.655-61.456-21.4-115.41-3.058-91.014 38.433-148.251 118.797-173.584 28.391-8.917 53.721-12.667 89.1-13.136 27.078-0.47 51.975-7.978 82.984-23.458 6.115-2.814 13.104-0.47 15.725 6.099 0.869 1.875 1.307 4.223 0.869 6.567l-0.432 3.284c-0.875 8.913-1.313 18.295-2.188 27.212-3.057 37.064-5.24 59.113-7.859 81.631-9.609 76.941-25.334 129.956-51.104 167.016-22.271 31.905-55.902 48.325-105.693 53.015a445.537 445.537 0 0 1-35.381 1.409H664.69c-15.724 0-24.459 0.939-31.011 2.814-0.874 0-2.62 0.47-3.932 0z m-2.62-53.015c-4.369 9.383-3.495 15.949 3.495 19.234 10.917 5.162 16.594-6.1 20.089-12.196 24.021-45.507 53.724-80.696 90.85-112.597 12.666-10.792 56.775-45.507 65.51-53.016 20.965-18.294 35.818-34.714 46.297-54.418 3.494-6.098 1.313-14.076-4.365-17.36-5.682-3.753-13.104-1.409-16.16 4.694-8.734 16.42-21.402 30.492-40.621 46.912-8.297 7.038-52.41 41.757-65.514 53.015-41.055 35.188-73.811 74.597-99.581 125.732z m0 0"
                  p-id="12848"
                  fill="#8a8a8a"
                ></path>
              </svg>
              <h2 style="margin: 0 0 0 10px">Species Information</h2>
            </div>
            <div class="info">
              <span>Organism: </span> <i>{{ info.organism }}</i
              > ({{ info.chineseName }})
            </div>
            <div class="info">
              <span>Genus: </span><i>{{ info.genus }}</i> ({{
                info.chineseGenus
              }})
            </div>
            <div class="info">
              <span>Family: </span>{{ info.family }} ({{
                info.chineseFamily
              }})
            </div>
            <div class="info"><span>Group: </span>{{ info.group ? info.group.replace(/Phycophyta/g, 'Algae') : info.group }}</div>
            <div class="title">
              <svg
                t="1705746760290"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="8559"
                width="32"
                height="32"
              >
                <path
                  d="M641.92 561.856c9.152 7.456 17.056 14.688 23.872 21.824 72.64 64.64 110.464 129.984 100.704 231.36l0.128 52.448V896h-63.968v-84.064c7.52-79.648-20.512-128.032-81.312-182.304-2.976-3.04-9.6-9.12-19.872-18.176l40.448-49.6zM767.68 128l-0.064 95.584c3.008 57.568-12.224 108.32-44.064 148.48-31.552 48.16-78.464 89.504-149.408 137.632a10373.28 10373.28 0 0 0-105.792 68.736c-30.912 20.544-50.976 35.904-65.696 51.2-60.8 54.272-88.832 102.656-81.312 182.304V896h-64l0.16-80.96c-9.76-101.376 28.096-166.72 100.704-231.36 15.456-16.224 36-32.32 65.6-52.416l15.84-10.496c13.024-8.48 41.824-27.104 86.368-55.808 71.424-47.456 116.608-86.112 145.696-130.24 23.584-29.984 34.24-65.408 32-109.472V128h63.968z m-127.488 672v64h-256v-64h256z m-32-128v64h-192v-64h192zM320.32 128v97.248c-2.272 44.064 8.384 79.488 32 109.44 12.704 19.2 27.744 36.672 46.208 54.08l9.504 8.736-42.56 47.808c-26.784-23.872-48.48-48-65.024-73.248C270.624 334.4 255.328 287.456 256 234.304L256.32 128h63.968z m287.872 160v64h-192V288h192z m32-128v64h-256V160h256z"
                  fill="#8a8a8a"
                  p-id="8560"
                ></path>
              </svg>
              <h2 style="margin: 0 0 0 10px">Mitogenome Feature</h2>
            </div>
            <div class="info">
              <span>Assembly: </span
              ><el-link
                type="primary"
                :href="url_nc"
                target="_blank"
                style="font-weight: 450; margin-bottom: 2px;"
                >{{ info.assembly }}</el-link
              >
            </div>
            <div class="info"><span>Size: </span>{{ info.size }} bp </div>
            <div class="info"><span>GC content: </span>{{ info.gc }}%</div>
          </div>
        </div>

        <div class="col" style="width: 400px">
          <div class="inner">
            <div class="title">
            <svg
              t="1705746935544"
              class="icon"
              viewBox="0 0 1033 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="10826"
              width="25"
              height="25"
            >
              <path
                d="M455.064001 534.856425L50.584436 342.490632a73.142921 73.142921 0 0 1 0-136.410853l404.479565-192.365794a146.285843 146.285843 0 0 1 123.245868 0l404.479565 192.365794a73.142921 73.142921 0 0 1 0 136.410853l-404.479565 192.365793a146.285843 146.285843 0 0 1-123.245868 0z"
                p-id="10827"
                fill="#8a8a8a"
              ></path>
              <path
                d="M516.686935 792.136149a191.816794 191.816794 0 0 1-84.845909-19.748979l-396.799574-197.119788a54.856941 54.856941 0 1 1 48.639948-97.827895L480.114974 674.559275a83.74891 83.74891 0 0 0 73.142922 0l396.799573-197.119788a54.856941 54.856941 0 1 1 48.639948 97.827895l-397.165573 197.119788a191.268795 191.268795 0 0 1-84.844909 19.748979z"
                p-id="10828"
                fill="#8a8a8a"
              ></path>
              <path
                d="M516.686935 1023.9989a191.268795 191.268795 0 0 1-84.845909-19.748979l-396.799574-197.119788a54.856941 54.856941 0 1 1 48.639948-97.827895l396.433574 197.119788a82.468911 82.468911 0 0 0 73.142922 0l396.799573-197.119788a54.856941 54.856941 0 1 1 48.639948 97.827895l-397.165573 197.119788A191.268795 191.268795 0 0 1 516.686935 1023.9989z"
                p-id="10829"
                fill="#8a8a8a"
              ></path>
            </svg>
            <h2 style="margin: 0 0 0 10px">Gene Feature</h2>
          </div>
          <div class="pmg-container">
            <el-carousel
              trigger="click"
              height=" 500px"
              :interval="3000"
              arrow="always"
              style="width: 100%"
              indicator-position="outside"
            >
              <el-carousel-item v-for="item in imageUrls" :key="item">
                <img
                  :src="item"
                  style="width: 100%"
                  alt="Image not found..."
                  :title="item"
                />
              </el-carousel-item>
            </el-carousel>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="table-toggle-container">
          <div class="table-toggle">
            <div
              :class="['toggle-btn', { active: nowShow === 'Genes' }]"
              @click="changeShow('Genes')"
            >
              Genes
            </div>
            <div
              :class="['toggle-btn', { active: nowShow === 'SSRs' }]"
              @click="changeShow('SSRs')"
            >
              SSRs
            </div>
          </div>
        </div>

        <div v-show="nowShow === 'Genes'">
          <div style="margin: 0px 0 10px 0">
            <!--搜索栏，页面大小调整栏-->

            <el-col :span="18" style="display: flex; align-items: center;">
            <el-input
              v-model="userInput"
              @input="inputContent"
              style="width: 500px"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="loadGenesList"
              ></el-button>
            </el-input>
          </el-col>
          <div style="width: 15%; float: right">
            <!-- 调整页面大小 -->
            Show
            <el-dropdown @command="changeValue">
              <el-button type="info" size="small">
                <span>{{ queryInfo.pagesize }}</span
                ><i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="item in option"
                  :key="item.value"
                  :command="item.label"
                  ><span> {{ item.label }}</span></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            entries
          </div>
        </div>
        <template>
          <el-table
            :data="genesList"
            id="educe-table"
            style="width: 100%"
            highlight-current-row
            justify="center"
            stripe
            @sort-change="sortChange"
            border
          >
            <el-table-column
              prop="geneName"
              label="Gene name"
              fixed="left"
              width="130"
              sortable="custom"
            >
            </el-table-column>
            <el-table-column
              prop="genesGroup"
              label="Gene group"
              width="200"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="length"
              label="CDS length (bp)"
              width="170"
              sortable="custom"
            ></el-table-column>
<!-- 去掉列表中的location列 -->
            <el-table-column
              prop="location"
              label="Start"
              width="100"
              v-if="!showDiv"
            >
              <template slot-scope="scope">
                {{ scope.row.location.split(':')[0].replace(/[^\d]/g, '') }}
              </template>
            </el-table-column>
            <el-table-column
              prop="location"
              label="End"
              width="100"
              v-if="!showDiv"
            >
              <template slot-scope="scope">
                {{ scope.row.location.split(':')[1].split(']')[0] }}
              </template>
            </el-table-column>
            <el-table-column
              prop="location"
              label="Strand"
              width="100"
              v-if="!showDiv"
            >
              <template slot-scope="scope">
                {{ scope.row.location.split('(')[1].split(')')[0] }}
              </template>
            </el-table-column>
<!-- location -->
            <el-table-column
              prop="definition"
              label="Definition"
              width="290"
            ></el-table-column>
            <el-table-column label="Protein" width="340">
              <template slot-scope="scope">
                <el-popover
                  placement="bottom"
                  width="340"
                  trigger="click"
                  :content="nowShowProtein"
                >
                  <el-button
                    class="table-button-ellipsis"
                    @click="getNowProtein(scope.row.proteinSequence)"
                    slot="reference"
                    ><span style="width: 100px">{{
                      scope.row.proteinSequence
                    }}</span></el-button
                  >
                </el-popover></template
              >
            </el-table-column>
            <el-table-column label="CDS" width="340">
              <template slot-scope="scope">
                <el-popover
                  placement="bottom"
                  width="340"
                  trigger="click"
                  :content="nowShowSequence"
                >
                  <el-button
                    class="table-button-ellipsis"
                    @click="getNowSequence(scope.row.sequence)"
                    slot="reference"
                    ><span style="width: 100px">{{
                      scope.row.sequence
                    }}</span></el-button
                  >
                </el-popover></template
              >
            </el-table-column>
          </el-table>
        </template>

        <div style="display: flex; margin: 20px 0">
          <div
            class="block"
            style="margin-top: 20px; width: 600px; display: inline-block"
          >
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="queryInfo.pagesize"
              layout="prev, pager, next, jumper"
              :total="count"
              :current-page.sync="queryInfo.pagenum"
            >
            </el-pagination>
          </div>
          <span
            style="
              margin-top: 25px;
              display: inline-block;
              float: right;
              margin-right: 170px;
            "
            >Showing {{ count == 0 ? 0 : (queryInfo.pagenum - 1) * 10 + 1 }} to
            {{
              queryInfo.pagenum * queryInfo.pagesize > count
                ? count
                : queryInfo.pagenum * queryInfo.pagesize
            }}
            of {{ count }} entries</span
          >
          <div style="margin: 20px 5px; float: right">
            <el-button @click="tableDOWNLOAD">Table download</el-button>
          </div>
          <div style="margin: 20px 5px; float: right">
            <el-button @click="fastaDOWNLOAD">Fasta download</el-button>
          </div>
        </div>
        </div>

        <div v-show="nowShow === 'SSRs'">
          <div style="margin: 0px 0 10px 0">


            <el-col :span="18" style="display: flex; align-items: center;">
            <el-input
              v-model="userInput"
              @input="ssrsinputContent"
              style="width: 500px"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="loadSSRsList"
              ></el-button>
            </el-input>
          </el-col>
          <div style="width: 15%; float: right">
            Show
            <el-dropdown @command="ssrschangeValue">
              <el-button type="info" size="small">
                <span>{{ ssrsqueryInfo.pagesize }}</span
                ><i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="item in option"
                  :key="item.value"
                  :command="item.label"
                  ><span> {{ item.label }}</span></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            entries
          </div>
        </div>
        <template>
          <el-table
            :data="ssrsList"
            id="educe-table"
            style="width: 100%"
            highlight-current-row
            justify="center"
            stripe
            @sort-change="ssrssortChange"
            border
          >
            <el-table-column
              prop="ssrtype"
              label="SSR type"
              fixed="left"
              width="200"
              sortable="custom"
            >
            </el-table-column>
            <el-table-column
              prop="repeatType"
              label="Repeat type"
              width="200"
              sortable="custom"
              :formatter="formatRepeatType"
            ></el-table-column>
            <el-table-column
              prop="start"
              label="Start"
              width="200"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="end"
              label="End"
              width="150"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="ssrsize"
              label="SSR size (bp)"
              width="200"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="ssr"
              label="SSR sequence"
              width="200"
              sortable="custom"
            ></el-table-column>

            <el-table-column
              prop="motif"
              label="Motif"
              sortable="custom"
            ></el-table-column>
          </el-table>
        </template>

        <div style="display: flex; margin: 20px 0">
          <div
            class="block"
            style="margin-top: 20px; width: 600px; display: inline-block"
          >
            <el-pagination
              @current-change="ssrshandleCurrentChange"
              :page-size="ssrsqueryInfo.pagesize"
              layout="prev, pager, next, jumper"
              :total="ssrscount"
              :current-page.sync="ssrsqueryInfo.pagenum"
            >
            </el-pagination>
          </div>
          <span
            style="
              margin-top: 25px;
              display: inline-block;
              float: right;
              margin-right: 280px;
            "
            >Showing
            {{ ssrscount == 0 ? 0 : (ssrsqueryInfo.pagenum - 1) * 10 + 1 }} to
            {{
              ssrsqueryInfo.pagenum * ssrsqueryInfo.pagesize > ssrscount
                ? ssrscount
                : ssrsqueryInfo.pagenum * ssrsqueryInfo.pagesize
            }}
            of {{ ssrscount }} entries</span
          >
          <div style="margin: 20px; float: right">
            <el-button @click="ssrsexcelDOWNLOAD">Excel download</el-button>
          </div>
        </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import count from "../../static/count.json";
// import { ref } from "vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Species",
  components: {  },
  data() {
    return {
      title: "Gene_Result",
      info: {},
      url_nc: "",
      genesList_fields: {
        geneName: "geneName",
        assembly: "assembly",
        geneID: "geneID",
        start: "start",
        end: "end",
        strand: "strand",
        protein: "protein",
        definition: "definition",
        locus: "locus",
        proteinSequence: "proteinSequence",
        sequence: "sequence",
      },
      genesList: [
        {
          geneName: "orf64",
          assembly: "NC_001660.1",
          geneID: 2702632,
          start: 1914,
          end: 2108,
          strand: "-",
          protein: "NP_054399.1",
          definition: "hypothetical protein",
          /*以下不展示*/
          locus: "MapooMp01",
          proteinSequence:
            "MKLLVYPLFTNVINNCGLRLKKSTNRKPKIHICFLFAEAVPITSNFDFQECLFFDSYLDLVRSV",
          sequence:
            "ATGAAATTACTAGTATATCCACTTTTCACTAATGTAATAAATAATTGCGGACTCCGGCTTAAAAAATCTA\nCTAATCGAAAACCGAAAATACACATATGTTTTTTGTTTGCCGAAGCCGTACCGATAACTTCAAATTTTGA\nTTTTCAAGAATGTTTGTTCTTCGATTCCTACCTTGATTTAGTAAGGTCGGTCTAG",
        },
      ],
      ssrsList: [],
      queryInfo: {
        pagenum: 1, //当前页面
        pagesize: 10, //页面大小
      },
      ssrsqueryInfo: {
        pagenum: 1, //当前页面
        pagesize: 10, //页面大小
      },
      count: 0,
      sort: "geneName",
      sortMethod: "ASC",
      ssrscount: 0,
      ssrssort: "start",
      ssrssortMethod: "ASC",
      option: [
        { label: 10, value: 0 },
        { label: 25, value: 1 },
        { label: 50, value: 2 },
        { label: 100, value: 3 },
      ],
      userInput: "",
      imageUrl: [],
      imageUrls: [],
      imageSpecies: "",
      nowShow: "Genes",
      nowShowProtein: "",
      nowShowSequence: "",
    };
  },
  created() {
    this.loadInfo();
    this.loadGenesList();
    this.loadSSRsList();
  },
  methods: {
  // 去掉最后一个字符
    formatRepeatType(row) {
      const value = row.repeatType;
      // 安全处理：如果有值才截取
      return value ? value.slice(0, -1) : '';
    },
    loadInfo() {
      // 从 sessionStorage 读取对象
      const retrievedObject = sessionStorage.getItem("info");
      const parsedObject = JSON.parse(retrievedObject);
      this.info = parsedObject;
      this.url_nc =
        "https://www.ncbi.nlm.nih.gov/nuccore/" + parsedObject.assembly.split("-")[0];
    },
    async loadGenesList() {
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get("/api/api.genes/list", {
          params: {
            page: this.queryInfo.pagenum,
            pageSize: this.queryInfo.pagesize,
            search: this.userInput,
            assembly: this.info.assembly,
            sort: this.sort,
            method: this.sortMethod,
          },
        });
        // 赋值
        this.genesList = res.data.rows;
        this.count = res.data.count;
      } catch (err) {
        console.log(err);
      }
    },
    async loadSSRsList() {
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get("/api/api.ssr/list", {
          params: {
            page: this.ssrsqueryInfo.pagenum,
            pageSize: this.ssrsqueryInfo.pagesize,
            search: this.userInput,
            assembly: this.info.assembly,
            sort: this.ssrssort,
            method: this.ssrssortMethod,
          },
        });
        // 赋值
        this.ssrsList = res.data.rows;
        this.ssrscount = res.data.count;
      } catch (err) {
        console.log(err);
      }
    },
    async changeValue(e) {
      //改变页面大小
      this.queryInfo.pagesize = e;
      this.handleCurrentChange(1);
    },
    async ssrschangeValue(e) {
      //改变页面大小
      this.ssrsqueryInfo.pagesize = e;
      this.ssrshandleCurrentChange(1);
    },
    async handleCurrentChange(val) {
      //底部分页按钮
      const { data: res } = await this.$axios.get("/api/api.genes/list", {
        params: {
          page: val,
          pageSize: this.queryInfo.pagesize,
          search: this.userInput,
          assembly: this.info.assembly,
          sort: this.sort,
          method: this.sortMethod,
        },
      });
      // 赋值
      this.queryInfo.pagenum = val;
      this.genesList = res.data.rows;
    },
    async ssrshandleCurrentChange(val) {
      //底部分页按钮
      const { data: res } = await this.$axios.get("/api/api.ssr/list", {
        params: {
          page: val,
          pageSize: this.ssrsqueryInfo.pagesize,
          search: this.userInput,
          assembly: this.info.assembly,
          sort: this.ssrssort,
          method: this.ssrssortMethod,
        },
      });
      // 赋值
      this.ssrsqueryInfo.pagenum = val;
      this.ssrsList = res.data.rows;
    },
    async inputContent(e) {
      this.userInput = e;
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get("/api/api.genes/list", {
          params: {
            page: 1,
            pageSize: this.queryInfo.pagesize,
            search: this.userInput,
            assembly: this.info.assembly,
            sort: this.sort,
            method: this.sortMethod,
          },
        });
        // 赋值
        this.queryInfo.pagenum = 1;
        this.count = res.data.count;
        this.genesList = res.data.rows;
        console.log(this.genesList);
      } catch (err) {
        console.log(err);
      }
    },
    async ssrsinputContent(e) {
      this.userInput = e;
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get("/api/api.ssr/list", {
          params: {
            page: 1,
            pageSize: this.ssrsqueryInfo.pagesize,
            search: this.userInput,
            assembly: this.info.assembly,
            sort: this.ssrssort,
            method: this.ssrssortMethod,
          },
        });
        // 赋值
        this.ssrsqueryInfo.pagenum = 1;
        this.ssrscount = res.data.count;
        this.ssrsList = res.data.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async sortChange(object) {
      this.sort = object.prop;
      if (object.order == "descending") {
        this.sortMethod = "DESC";
      } else if (object.order == "ascending") {
        this.sortMethod = "ASC";
      }
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get("/api/api.genes/list", {
          params: {
            page: 1,
            pageSize: this.queryInfo.pagesize,
            search: this.userInput,
            sort: this.sort,
            method: this.sortMethod,
            assembly: this.info.assembly,
          },
        });
        // 赋值
        this.queryInfo.pagenum = 1;
        this.count = res.data.count;
        this.genesList = res.data.rows;
      } catch (err) {
        console.log(err);
      }
      console.log(object);
    },
    async ssrssortChange(object) {
      this.ssrssort = object.prop;
      console.log(object.prop);
      if (object.order == "descending") {
        this.ssrssortMethod = "DESC";
      } else if (object.order == "ascending") {
        this.ssrssortMethod = "ASC";
      }
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get("/api/api.ssr/list", {
          params: {
            page: 1,
            pageSize: this.ssrsqueryInfo.pagesize,
            search: this.userInput,
            sort: this.ssrssort,
            method: this.ssrssortMethod,
            assembly: this.info.assembly,
          },
        });
        // 赋值
        this.ssrsqueryInfo.pagenum = 1;
        this.ssrscount = res.data.count;
        this.ssrsList = res.data.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async fastaDOWNLOAD() {
      const targetUrl =
        "http://www.pmgdb.cn" +
        "/api/api.genes/fasta?page=" +
        this.queryInfo.pagenum +
        "&pageSize=" +
        this.queryInfo.pagesize +
        "&search=" +
        this.userInput +
        "&sort=" +
        this.sort +
        "&method=" +
        this.sortMethod +
        "&assembly=" +
        this.info.assembly;
      // // 在新窗口中打开目标URL
      window.open(targetUrl);
      this.$router.go(0);
    },
    async ssrsexcelDOWNLOAD() {
      const targetUrl =
        "http://www.pmgdb.cn" +
        "/api/api.ssr/excel?page=" +
        this.ssrsqueryInfo.pagenum +
        "&pageSize=" +
        this.ssrsqueryInfo.pagesize +
        "&search=" +
        this.userInput +
        "&sort=" +
        this.ssrssort +
        "&method=" +
        this.ssrssortMethod +
        "&assembly=" +
        this.info.assembly;
      // // 在新窗口中打开目标URL
      window.open(targetUrl);
      this.$router.go(0);
    },
    async tableDOWNLOAD() {
      var targetUrl =
        "http://www.pmgdb.cn" +
        "/api/api.genes/excel?page=" +
        this.queryInfo.pagenum +
        "&pageSize=" +
        this.queryInfo.pagesize +
        "&search=" +
        this.userInput +
        "&sort=" +
        this.sort +
        "&method=" +
        "&assembly=" +
        this.info.assembly;
      // 在新窗口中打开目标URL
      window.open(targetUrl);
      this.$router.go(0);
    },
    fetchImages() {
      try {
        if (this.info.ring == "Single") {
          this.imageUrl = require(`../images/map_Single/${this.info.assembly.slice(
            0,
            -2
          )}_${this.info.structure}.png`);
          this.imageUrls = [
            require(`../images/map_Single/${this.info.assembly.slice(0, -2)}_${
              this.info.structure
            }.png`),
          ];
        } else if (this.info.ring == "Multiple") {
          if (count.results[this.info.assembly] != 0) {
            this.imageUrl = require(`../images/map_Multiple/${this.info.assembly}/contig1.png`);
            for (let i = 1; i <= count.results[this.info.assembly]; i++) {
              this.imageUrls.push(
                require(`../images/map_Multiple/${this.info.assembly}/contig${i}.png`)
              );
            }
          }
        }
      } catch (error) {
        this.imageUrl = require("../images/pmgDefault.png");
        this.imageUrls = [require("../images/pmgDefault.png")];
      }
    },
    fetchSpeciesImages() {
      try {
        this.imageSpecies = require(`../images/images_Species/${this.info.assembly}.jpg`);
      } catch (error) {
        this.imageSpecies = require("../images/speciesDefault.png");
      }
    },
    changeShow(e) {
      if (this.nowShow != e) {
        if (this.nowShow == "Genes") {
          this.nowShow = "SSRs";
        } else {
          this.nowShow = "Genes";
        }
      }
    },
    getNowProtein(e) {
      this.nowShowProtein = e;
    },
    getNowSequence(e) {
      this.nowShowSequence = e;
    },
  },
  mounted() {
    this.fetchImages();
    this.fetchSpeciesImages();
  },
  computed: {
    // 计算属性来判断是否展示div
    showDiv() {
      // 检查常值字符串中是否包含"-"
      return this.info.assembly.includes("-");
    },
  },
};
</script>

<style scoped>
.card {
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 20px 30px;
  margin-bottom: 25px;
}
.background {
  position: fixed;
  z-index: -1;
  left: 0;
  top: 0;
  width: 100%;
}
.background .glass {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 1950px;
  /* 模糊大小就是靠的blur这个函数中的数值大小 */
  backdrop-filter: blur(4px);
  transition: all linear 0.5s;
}
.background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.infos {
  display: flex;
  flex-wrap: wrap;
  background-color: white;
}
.col {
}
.info {
  margin: 20px 45px;
  width: 100%;
}
.info span {
  font-weight: 550;
  font-size: large;
}

.el-submenu__title:hover,
.el-menu-item:focus,
.el-menu-item:hover {
  background-color: cornflowerblue;
}
.title {
  display: flex;
}
.title svg {
  margin: auto 0 auto 0px;
}
.image-gallery img {
  width: 100%;
  height: auto;
}
.inner {
  margin: 20px;
}
.table-toggle-container {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}
.table-toggle {
  display: inline-flex;
  background-color: #f1f3f5;
  border-radius: 8px;
  padding: 4px;
}
.toggle-btn {
  padding: 8px 40px;
  font-size: 16px;
  font-weight: 600;
  color: #5c6b77;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
}
.toggle-btn:hover {
  color: #409EFF;
}
.toggle-btn.active {
  background-color: #ffffff;
  color: #409EFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.image-gallery svg {
  margin: 80px;
}
.table-button-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 290px;
}
.image-container {
  width: 450px; /* 可以根据需要设置宽度 */
  height: 520px; /* 可以根据需要设置高度 */
  overflow: hidden; /* 防止图片超出div */
  display: flex; /* 使用flex布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.pmg-container {
}
</style>